import { Link, useLocation } from "react-router-dom";
import { logo } from "../../../Assets/images";

import { useSelector } from "react-redux";
import "./style.css";

export const LINKS = [
  // {
  //   to: "/dashboard",
  //   title: "Dashboard",
  //   icon: faBorderAll
  // },
  {
    id: 1,
    to: "/resident-approvals",
    title: "Resident Approvals",
  },
  {
    id: 12,
    to: "/review-approvals",
    title: "Review Moderation",
  },
  {
    id: 2,
    to: "/vendor-requests",
    title: "Vendor Approval Requests",
  },
  {
    id: 3,
    to: "/profiles",
    title: "View Profiles",
  },
  {
    id: 13,
    to: "/vendor-ads",
    title: "Vendor Ads",
  },
  {
    id: 14,
    to: "/ad-pricing",
    title: "Ad Pricing",
  },
  {
    // Resident/vendor growth numbers. Lives at /statistics and was reachable only
    // by typing the URL before this entry existed — now it's one click from the nav.
    id: 17,
    to: "/statistics",
    title: "Statistics",
  },
  {
    id: 5,
    to: "/categories",
    title: "Categories",
  },
  {
    id: 7,
    to: "/payment-logs",
    title: "Payment Logs",
  },
  {
    id: 8,
    to: "/push-notifications",
    title: "Notifications",
  },
  {
    id: 10,
    to: "/neighborhoods",
    title: "Neighborhoods",
    superAdminOnly: false
  },
  {
    id: 11,
    to: "/admins",
    title: "Admin Management",
    superAdminOnly: true
  },
  {
    id: 15,
    to: "/family-management",
    title: "Marshall",
  },
  {
    id: 16,
    to: "/rangefinder",
    title: "Rangefinder",
  },
  {
    // 19th Hole is the neighborhood forum. This link lets admins
    // find and delete posts or comments that violate community guidelines.
    //
    // `alwaysShow: true` means every admin sees this link even though their
    // saved `access_to` list (set before this feature existed) doesn't include
    // id 18. Without this flag, existing admins would never see the link until
    // someone manually added 18 to each of their access lists in the DB.
    alwaysShow: true,
    id: 18,
    to: "/content-moderation",
    title: "19th Hole",
  },
]

export const Sidebar = (props) => {

  const { user } = useSelector(state => state.authSlice)
  const location = useLocation()

  // Filter routes based on user access and role.
  // A link shows if it's flagged `alwaysShow` OR the admin's saved access list
  // includes its id. The `alwaysShow` escape hatch exists for links added after
  // existing admins' access lists were set, so a new link isn't invisible to
  // everyone until each account's access_to is patched in the DB.
  let ROUTES = user?.access_to?.length > 0
    ? LINKS.filter(item => item.alwaysShow || user.access_to?.includes(item.id))
    : LINKS

  // Filter super admin only routes
  ROUTES = ROUTES.filter(item => {
    if (item.superAdminOnly && user?.role !== 'super_admin') {
      return false
    }
    return true
  })

  return (
    <div className={`sidebar ${props.sideClass}`} id="sidebar">
      <Link to={"/vendor-requests"} className="siteLogo order-2 order-lg-1 py-3">
        <img src={logo} alt="The Turn" className="siteLogoMark" />
      </Link>
      <p className="sidebarSectionLabel">Operations</p>
      <ul className="list-unstyled mt-5">
        {
          ROUTES.map((item) => (
            <li key={item.to} className="sidebar-li">
              <Link className={`sideLink ${location.pathname.includes(item.to) ? 'active' : ''}`} to={item.to}>
                {/* <span className="sideIcon">
                  <FontAwesomeIcon icon={item.icon} />
                </span> */}
                <span className="sideLinkText">{item.title}</span>
              </Link>
            </li>
          ))
        }
      </ul>
    </div>
  );
};
